document.addEventListener('DOMContentLoaded', function () {
  if (window.customDropdownInit) return; // prevent duplicate binding
  window.customDropdownInit = true;

  document.addEventListener('click', function () {
    document.querySelectorAll('[data-dropdown]').forEach((drop) => {
      drop.classList.remove('open');
      drop.querySelector('[data-menu]').classList.remove('open');
    });
  });

  document.querySelectorAll('[data-dropdown]').forEach((dropdown) => {
    const toggle = dropdown.querySelector('[data-toggle]');
    const menu = dropdown.querySelector('[data-menu]');
    const title = dropdown.querySelector('[data-title]');
    const input = dropdown.querySelector('[data-dropdown-input]');
    const items = dropdown.querySelectorAll('[data-item]');

    dropdown.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    toggle.addEventListener('click', function () {
      const isOpen = dropdown.classList.contains('open');
      document.querySelectorAll('[data-dropdown]').forEach((d) => {
        d.classList.remove('open');
        d.querySelector('[data-menu]').classList.remove('open');
      });
      if (!isOpen) {
        dropdown.classList.add('open');
        menu.classList.add('open');
      }
    });

    items.forEach((item) => {
      item.addEventListener('click', function () {
        title.textContent = item.textContent.trim();
        input.value = item.getAttribute('value');
        console.log(input.value, item.textContent);

        dropdown.classList.remove('error');
        dropdown.classList.add('valid');

        dropdown.classList.remove('open');
        menu.classList.remove('open');

        items.forEach((i) => i.classList.remove('custom-dropdown-item-selected'));
        this.classList.add('custom-dropdown-item-selected');
      });
    });
  });
});
